<section class="p-8">
    <p class="text-blue-800 text-lg">Course: {{course.title}} </p>
    <p>{{course.description}}</p>
    <p>Presented for you by: Practical IT</p>
    <section class="text-lg text-red-950">Course Content</section>
    <ng-container class="bg-red-500" *ngFor="let chapter of course?.chapters; let i = index">
        <section
            class="text-md p-6 bg-gray-50 h-10 text-black-800 m-1 capitalize gap-2 cursor-pointer flex items-center"
            (click)="setCurrentIndex(i)">
            <span class="text-black font-bold">{{chapter.title}} </span>
            <span class="text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 transform transition-transform"
                    [ngClass]="{ 'rotate-180': currentIndex==i }" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
            </span>
        </section>
        <ng-container *ngIf="currentIndex==i">
            <section *ngFor="let lesson of chapter?.lessons"
                class="flex justify-between w-full text-sm px-10 my-2 text-blue-600 cursor-pointer">
                <span class="flex-1">
                    {{lesson.order}} {{lesson.title}}
                </span>
                <span class="flex-1 flex justify-center">
                    {{lesson.videos[0].durationHours ? lesson.videos[0].durationHours + ":" : ""}}
                    {{lesson.videos[0].durationMinutes? (+lesson.videos[0].durationMinutes < 10 ? "0"
                        +lesson.videos[0].durationMinutes : lesson.videos[0].durationMinutes)+"m" : "00m"
                        }}:{{lesson.videos[0].durationSeconds ? (+lesson.videos[0].durationSeconds < 10 ? "0"
                        +lesson.videos[0].durationSeconds : lesson.videos[0].durationSeconds)+"s" : "00s" }} </span>
            </section>
        </ng-container>
    </ng-container>
</section>